import { Component } from '@angular/core';
import { ModalComponent } from '../../modal-service/modal.service';
import { ProductWarningNotesModel } from '../models/product-warnings-notes-model';
import { Helper } from 'app/shared/helper';

@Component({
  selector: 'app-product-warning-notes',
  templateUrl: './product-warning-notes.component.html',
  styleUrls: ['./product-warning-notes.component.css']
})
export class ProductWarningNotesComponent extends ModalComponent<boolean> {
  warnings: string[];
  continueActionKey: string = null;
  continueActionResourceKey: string = null;
  cancelActionResourceKey: string = null;
  isAlert: boolean = false;
  showSkip: boolean = false;

  init(model: ProductWarningNotesModel) {
    this.warnings = model.warnings;
    this.continueActionResourceKey = model.continueActionResourceKey;
    this.cancelActionResourceKey = model.cancelActionResourceKey;
    this.showSkip = model.showSkip;
    this.isAlert = model.isAlert;
    if (model.isAlert === true)
      this.continueActionKey = 'FC.ProductWarningsNotes.OK';
    else
      this.continueActionKey = 'FC.ProductWarningsNotes.Continue';
  }

  skipToNextTab(): void {
    this.closeModal(false);
    Helper.flowToNextTab();
  }

  closeModal(result: boolean): void {
    this.modalRef.close(result);
    this.showSkip = false;
  }
}
